import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { Business } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './BusinessSwitcherLogo.module.scss';
export const getBussinessLogoTID = (parentTestId)=>getTestIds(parentTestId);
export const BusinessSwitcherLogo = (param)=>{
    let { testId, src, fullLogo } = param;
    const { BussinessLogoTID } = useMemo(()=>getBussinessLogoTID(testId), [
        testId
    ]);
    const [imageState, setImageState] = useState('loading');
    useEffect(()=>{
        setImageState('loading');
    }, [
        src
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": BussinessLogoTID.Root(),
        children: [
            [
                'loading',
                'error'
            ].includes(imageState) && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.image, {
                    [styles.fullLogo]: fullLogo
                }),
                "data-testid": BussinessLogoTID.NoLogoImage(),
                children: /*#__PURE__*/ _jsx(Business, {})
            }),
            imageState !== 'error' && /*#__PURE__*/ _jsx("img", {
                src: src || '',
                "data-testid": BussinessLogoTID.LogoImage(),
                className: cn(styles.image, {
                    [styles.fullLogo]: fullLogo
                }, {
                    [styles.loadingLogoImage]: imageState === 'loading'
                }),
                onLoad: ()=>{
                    setImageState('loaded');
                },
                onError: ()=>{
                    setImageState('error');
                }
            })
        ]
    });
};
